/* global UserVoice */
import Promise from 'bluebird';

let resolveContext;
const p$context = new Promise((resolve) => {
  resolveContext = resolve;
});

export function init(context) {
  resolveContext(context);
  return p$context;
}

// This function popups the UV widget, but anchored to a custom target other than
// the trigger itself.
// Useful when the trigger is a dropdown submenu.
function addTargetedTrigger({
  triggerId,
  featureName,
  areaName,
  targetId,
}) {
  return p$context.then(({
    user,
    account,
    customer,
    i18n,
  }) => {
    const userVoice = UserVoice || [];

    userVoice.push(['identify', {
      // BingAds user ID
      id: user.Id,

      account: {
        // BingAds account ID
        id: account.Id,

        // BingAds account number
        name: account.AccountNumber,
      },
    }]);

    userVoice.push(['set', {
      ticket_custom_fields: {
        UserAgent: navigator.userAgent,
        Feature: featureName,
        FeatureArea: areaName,
        URL: window.location.href,
        AccountNumber: account.AccountNumber,
        AccountName: account.Name,
        AccountID: account.Id,
        CustomerID: customer.Id,
        CustomerName: customer.Name,
        PageHTML: '',
      },
      smartvote_enabled: false,

      target: targetId,

      screenshot_enabled: false,

      strings: {
        contact_menu_label: i18n.getString('UserVoice_WidgetText_ContactMenuLabel'),
        contact_title: i18n.getString('UserVoice_WidgetText_ContactTitle'),
        contact_message_placeholder: i18n.getString('UserVoice_WidgetText_ContactMessagePlaceholder'),
        contact_skip_instant_answers_button: i18n.getString('UserVoice_WidgetText_ContactSkipInstantAnswersButton'),
        contact_details_title: i18n.getString('UserVoice_WidgetText_ContactDetailsTitle'),
        contact_submit_button: i18n.getString('UserVoice_WidgetText_ContactSubmitButton'),
        contact_success_title: i18n.getString('UserVoice_WidgetText_ContactSuccessTitle'),
        contact_success_body: i18n.getString('UserVoice_WidgetText_ContactSuccessBody'),
        email_address_label: i18n.getString('UserVoice_WidgetText_EmailAddressLabel'),
        email_address_placeholder: i18n.getString('UserVoice_WidgetText_EmailAddressPlaceholder'),
      },
    }]);

    userVoice.push(['addTrigger', triggerId, {
      mode: 'contact',
    }]);
  });
}

// Popups a UV contact widget, and place the anchor to the trigger itself.
export function addTrigger({
  triggerId,
  featureName,
  areaName,
}) {
  return addTargetedTrigger({
    triggerId,
    featureName,
    areaName,
    targetId: 'self',
  });
}
